// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__uksdi","bottom":"menu_bottom__GZwNz"};